import { makeStyles } from '@material-ui/core/styles';
import { isIE } from 'helpers/detectEdgeIE';

// We want to kill this implementation asap

const useTempIEStyles = makeStyles(() => ({
  menuItem: isIE() ? {
        display: 'flex !important',
        justifyContent: 'flex-start',
        padding: '7px 10px',
      } : {},
}));

export default useTempIEStyles;



// WEBPACK FOOTER //
// ./src/components/Login/useTempIEStyles.js